import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useMatchingRoles } from './hooks/useMatchingRoles.js';
import { MatchingSubMenu } from './components/MatchingSubMenu.jsx';

/**
 * Layout wrapper para las páginas de Matching.
 * Renderiza el SubMenu solo si el usuario tiene el rol sge_view_all.
 */
export function MatchingLayout({ children }) {
    const { canViewBoth } = useMatchingRoles();
    const location = useLocation();
    const currentPath = location.pathname;

    return (
        <>
            {canViewBoth && <MatchingSubMenu currentPath={currentPath} />}
            {children}
        </>
    );
}

MatchingLayout.propTypes = {
    children: PropTypes.node.isRequired,
};
